import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/todo/hyperlinks-form.scss';
import { matches, closest } from '@material/dom/ponyfill';

Component('tr-todo-hyperlinks-form', {
  mixins: [eventListenerMixin],

  ready() {
    this.listenTo(this, 'click', this.handleClick.bind(this));
  },

  handleClick(e) {
    if (matches(e.target, '.add-hyperlink')) {
      e.target.insertAdjacentHTML('beforebegin', e.target.dataset.template);
    } else if (matches(e.target, '.remove-hyperlink')) {
      closest(e.target, '.hyperlink').remove();
    }
  },

  disconnected() {
    this.stopListening();
  },
});
